<template>
  <div class="ProjectLogg">
    <div class="ProjectLogg--header">
      <h1>{{ $t('Project Log') }}</h1>
      <div class="sub-header">
        <span style="display: flex; justify-content: flex-end; width: 100%">
          <div class="right-item">
            <label for="lateControls">{{ $t('Ändra av') }}</label>
            <div class="user-name">
              Rikard hansson
              <img src="static/arrow-down-drop-circle.png" />
            </div>
          </div>
          <div class="right-item">
            <label for="lateControls">{{ $t('Flyttade I tld') }}</label>
            <div class="switch">
              <input type="checkbox" />
              <label><i></i></label>
            </div>
          </div>
          <div class="right-item">
            <label for="lateControls">{{ $t('Avbockade') }}</label>
            <div class="switch">
              <input type="checkbox" checked />
              <label><i></i></label>
            </div>
          </div>
          <div class="right-item">
            <label for="lateDeliveries">{{ $t('Raderade') }}</label>
            <div class="switch">
              <input type="checkbox" checked />
              <label><i></i></label>
            </div>
          </div>
          <div class="right-item">
            <label for="onlyMine">{{ $t('Visa Allt') }}</label>
            <div class="switch">
              <input type="checkbox" checked />
              <label><i></i></label>
            </div>
          </div>
        </span>
      </div>
    </div>

    <table class="alerts">
      <transition-group name="list" tag="thead">
        <tr v-for="log in logs" :key="log._id">
          <td class="datecolumn">
            <div class="lable">RH</div>
            {{ formatTimeStamp(log.timestamp) }}
          </td>
          <td class="stagecolumn">
            {{ log.user }}
          </td>
          <td class="plancolumn">
            <router-link
              v-if="log.object.type == 'Part'"
              :to="{ name: 'ProjectPlanPart', params: { _id: $route.params._id, partId: log.object.id } }"
            >
              {{ log.object ? log.object.title : log.title }}
            </router-link>
            <router-link
              v-else-if="log.object.type == 'Stage'"
              :to="{ name: 'ProjectPlanStage', params: { _id: $route.params._id, stageId: log.object.id } }"
            >
              {{ log.object ? log.object.title : log.title }}
            </router-link>
            <span v-else>
              {{ log.object ? log.object.title : log.title }}
            </span>
          </td>
          <td class="commentcolumn">
            {{ $t(log.reason) }}
          </td>
          <td class="timecolumn_1">
            <ul>
              <li v-for="(data, item) in log.update">
                {{ $t('Changed "{item}" to "{data}"', { item, data }) }}
              </li>
            </ul>
          </td>
        </tr>
      </transition-group>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  data() {
    return {
      logs: [],
      loading: true,
    };
  },

  mounted() {
    this.loadLogs(this.$route.params._id);
  },

  methods: {
    ...mapActions(['getProjectLog']),

    formatTimeStamp(stamp) {
      return moment(stamp).format('YYYY-MM-DD HH:mm:ss');
    },

    async loadLogs(projectId) {
      this.loading = true;

      try {
        this.logs = await this.getProjectLog({ projectId });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/** @todo Lots of unused styles - need cleanup. */
.ProjectLogg {
  padding: 1px 20px;
  background: #091d2f;
}

.ProjectLogg--header {
  margin: 10px 0;
  padding: 10px 0;
  border-bottom: 3px solid #3f414c9e;
  display: flex;
  flex-direction: column;
}

.ProjectLogg--header h1 {
  text-transform: uppercase;
}

.sub-header {
  display: flex;
  justify-content: space-between;
}
.sub-header .right-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 20px;
}
.sub-header .right-item:last-child {
  margin-right: 0;
}
.sub-header .right-item .user-name {
  background: #3f414c9e;
  padding: 5px;
  border-radius: 25px;
  margin-left: 10px;
  font-size: 12px;
  display: flex;
  padding-left: 10px;
}
.sub-header .right-item .user-name img {
  /* background: #091D2F; */
  /* border-radius: 100%; */
  width: 16px;
  height: 16px;
  /* display: flex; */
  margin-left: 10px;
  /* justify-content: center; */
}
.ProjectLogg .switch {
  margin-left: 10px;
}
table {
  font-size: 0.8em;
  width: 100%;
  border-collapse: collapse;
}

table tr {
  border-top: 1px solid #374653;
  border-bottom: 1px solid #374653;
}

table tr td {
  padding: 0.2em 0.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 0;
  width: 12%;
  text-align: left;
}
table tr td.datecolumn {
  width: 10%;
  padding-left: 0;
}
table tr td.datecolumn .lable {
  background: #fff;
  border-radius: 100%;
  color: #000;
  font-weight: 600;
  height: 25px;
  width: 25px;
  align-items: center;
  justify-content: center;
  display: inline-flex;
}

table tr td.stagecolumn {
  width: 20%;
}
table tr td.plancolumn {
  font-weight: 400;
}
table tr td.timecolumn_1 {
  color: #8c8d8c;
  text-decoration: line-through;
}
/* table tr td:first-of-type {
    width: 32%;
  } */
table tr td:nth-of-type(3) {
  width: 24%;
}

table tr td:nth-of-type(4) {
  width: 12%;
}
table tr td:last-child {
  padding-right: 0;
  text-align: right;
}
.stagecolumn,
.commentText {
  color: #8c8d8c;
  background: transparent;
}

.stagecolumn {
  direction: rtl;
  text-align: left;
}

@media (max-width: 1280px) {
  .sub-header {
    flex-direction: column;
  }
}
@media (max-width: 1024px) {
  .sub-header span {
    flex-direction: column;
  }
  .sub-header .right-item {
    display: flex;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/projectoverview/ProjectLogUpdate.vue